import request from "@utils/request";

export function getPositionChart(query) {
    return request({
        url: "influx_data/broker_position",
        method: "get",
        params: query,
    });
}
